import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient, ROOT_URL } from "../App";

export const useGetListNotification = ({
  type,
  start,
  end,
}: {
  type?: string;
  start: number;
  end: number;
}) => {
  return useQuery<{ data: { data: any } }>(
    [`/api/v1/notifications/get-list`, type, start, end],
    async () => getListNotification({ type, start, end }),
    {
      keepPreviousData: true,
    }
  );
};

export function getListNotification({
  type,
  start,
  end,
}: {
  type?: string;
  start: number;
  end: number;
}) {
  const params = new URLSearchParams();
  params.append("_start", String(start));
  params.append("_end", String(end));
  switch (type) {
    case "READ":
      params.append("_read", "1");
      break;
    case "UN_READ":
      params.append("_read", "0");
      break;
    default:
      break;
  }
  return httpClient.get(
    `${ROOT_URL}/api/v1/notifications/get-list?${params.toString()}`
  );
}

export const useReadNotification = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: readNotification,
  });
};

export function readNotification(body: any) {
  return httpClient.put(`${ROOT_URL}/api/v1/notifications/read`, body);
}
